import React, { useState } from 'react'

import ReactFC from "react-fusioncharts";
import FusionCharts from "fusioncharts";
import Column2D from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

export default function VisitChart({monthList, m_visitorApplicationInfo, m_visitorInfo}) {

    const category = [{
        "category" : monthList
    }];

    const chartConfigs = {
        type: "mscolumn2d",
        width: "100%",
        height: "500",
        dataFormat: "json",
        dataSource: {
            chart: {
                caption: "월별 방문 현황",
                theme: "fusion",
            },
            categories: category,
            dataset: [
                {
                    "seriesname": "방문신청",
                    "data": m_visitorApplicationInfo
                },
                {
                    "seriesname": "방문객",
                    "data": m_visitorInfo
                }
            ]
        }
    };
    return (<ReactFC {...chartConfigs} />);
}